// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { MarkingSystemProjectCreationService } from './marking-system-project-creation.service';

@Injectable({providedIn: 'root'})
export class MarkingSystemProjectCreationServiceDelegator {

  private _markingSystemProjectCreationService: MarkingSystemProjectCreationService;

  set markingSystemProjectCreationService(value: MarkingSystemProjectCreationService) {
    this._markingSystemProjectCreationService = value;
  }

  public async updateMarkingSystemPredefinedAreas(): Promise<void> {
    return this._markingSystemProjectCreationService.updateMarkingSystemPredefinedAreas();
  }

  public async projectRefreshedSuccess(): Promise<void> {
    return this._markingSystemProjectCreationService.projectRefreshedSuccess();
  }

  public errorHandler() {
    this._markingSystemProjectCreationService.errorHandler();
  }
}
